import report from '../entity/report.de.ts'
import person from '../entity/person.de.ts'
import updaterequest from 'plugins/i18n/entity/updaterequest.de.ts'
import meter from 'plugins/i18n/entity/meter.de.ts'
import meterLevel from 'plugins/i18n/entity/meterLevel.de.ts'
import craftsman_task from 'plugins/i18n/entity/craftsmanTask.de.ts'
import task from 'plugins/i18n/entity/task.de.ts'
import cis from 'plugins/i18n/entity/cis.de.ts'
import document from 'plugins/i18n/entity/document.de.ts'
import comment from 'plugins/i18n/entity/comment.de.ts'
import email from 'plugins/i18n/entity/email.de.ts'
import address from 'plugins/i18n/entity/address.de.ts'
import notification from 'plugins/i18n/entity/notification.de.ts'
import note from 'plugins/i18n/entity/note.de.ts'
import role from 'plugins/i18n/entity/role.de.ts'
import phonenumber from 'plugins/i18n/entity/phonenumber.de.ts'
import building from 'plugins/i18n/entity/building.de.ts'
import unit from 'plugins/i18n/entity/unit.de.ts'
import handoverProtocol from 'plugins/i18n/entity/handoverProtocol.de.ts'
import documenttype from 'plugins/i18n/entity/documenttype.de.ts'
import permission from 'plugins/i18n/entity/permission.de.ts'
import team from 'plugins/i18n/entity/team.de.ts'
import review_document from 'plugins/i18n/entity/reviewDocument.de.ts'
import journal from 'plugins/i18n/entity/journal.de.ts'
import sync from 'plugins/i18n/entity/sync.de.ts'
import user from 'plugins/i18n/entity/user.de.ts'
import invoice from 'plugins/i18n/entity/invoice.de.ts'
import account from 'plugins/i18n/entity/account.de.ts'
import ticket from 'plugins/i18n/entity/ticket.de.ts'
import faq from 'plugins/i18n/entity/faq.de.ts'
import handovertemplate from 'plugins/i18n/entity/handovertemplate.de.ts'
import notestype from 'plugins/i18n/entity/notestype.de.ts'
import reportType from 'plugins/i18n/entity/reportType.de.ts'
import reportStatus from 'plugins/i18n/entity/reportStatus.de.ts'
import personsaccount from 'plugins/i18n/entity/personsAccount.de.ts'
import readable from 'plugins/i18n/entity/readable.de.ts'
import sync_failure from 'plugins/i18n/entity/syncFailure.de.ts'
import sync_update_reason from 'plugins/i18n/entity/syncUpdateReason.de.ts'
import person_access_rejection from 'plugins/i18n/entity/personAccessRejection.de.ts'

const entity = {
	address,
	building,
	craftsman_task,
	cis,
	comment,
	document,
	documenttype,
	email,
	note,
	notification,
	task,
	team,
	person,
	report,
	role,
	updaterequest,
	meter,
	meterLevel,
	phonenumber,
	unit,
	handoverProtocol,
	permission,
	review_document,
	journal,
	sync,
	user,
	invoice,
	account,
	ticket,
	faq,
	handovertemplate,
	notestype,
	reportType,
	reportStatus,
	personsaccount,
	readable,
	sync_failure,
	sync_update_reason,
	person_access_rejection,
}

export default entity
